export default __webpack_public_path__ + "locales/az/UploadPanel.json?hash=09191665a2d471c66a939aa3c9b152fa";